<template>
  <div class="full-width">
    <div
      layout="column"
      layout-align="start start"
      class="full-width pr2-pc pl2-pc mb20-pc pb1-pc mb2-mobile pr1-mobile pl1-mobile bg-white"
    >
      <div
        layout="row"
        layout-align="start center"
        class="title grey--text text-uppercase font-weight-medium mb2-pc mb1-mobile mt3-pc"
      >{{$t('nav.docs')}}
        <v-btn
          @click="displayFilters = !displayFilters"
          icon
          class="hidden-md-and-up mx-0 ml-1"
        ><i
            :class="['mdi', displayFilters ? 'mdi-filter-remove' : 'mdi-filter']"
            style="color: black"
          ></i></v-btn>

        <v-btn
          v-if="isEditor"
          @click="newFolder"
          icon
          class="hidden-md-and-up mx-0"
          :disabled="!editable || searching"
        >
          <v-icon color="secondary">mdi-folder-plus-outline</v-icon>
        </v-btn>
        <v-btn
          v-if="isEditor"
          @click="editFolder(currentFolder)"
          :disabled="!currentFolder || currentFolder.name == 'folder-national' || !editable || searching"
          icon
          class="hidden-md-and-up mx-0"
        >
          <v-icon color="green">mdi-folder-edit-outline</v-icon>
        </v-btn>
        <v-btn
          v-if="isEditor"
          @click="deleteFolderDialog = true"
          :disabled="!currentFolder || currentFolder.name == 'folder-national' || !editable || searching"
          icon
          class="hidden-md-and-up mx-0"
        >
          <v-icon color="red">mdi-folder-remove-outline</v-icon>
        </v-btn>
        <v-btn
          v-if="isEditor"
          @click="newFile"
          :disabled="!editable || searching"
          icon
          class="hidden-md-and-up mx-0"
        >
          <v-icon color="secondary">mdi-file-plus</v-icon>
        </v-btn>
      </div>
      <div
        v-if="!$vuetify.breakpoint. smAndDown || displayFilters"
        layout="row"
        layout-wrap
        layout-align="start center"
        class="full-width"
      >
        <div
          layout="column"
          :flex="$vuetify.breakpoint. smAndDown ? 100 : 33"
        >
          <v-text-field
            solo
            :label="$t('filters.keywords')"
            :hint="$t('ged.keywords_hint')"
            persistent-hint
            v-model="filters.keywords"
            @keyup.enter="fetch"
            class="mr5-pc width-100-mobile"
          ></v-text-field>
        </div>
        <div
          layout="column"
          :flex="$vuetify.breakpoint. smAndDown ? 100 : 33"
        >
          <v-select
            :label="$t('ged.sent_by')"
            :hint="$t('ged.lv_hint')"
            persistent-hint
            multiple
            solo
            v-model="filters.level"
            :items="levels"
            @change="fetch"
            class="mr5-pc ml5-pc width-100-mobile"
          >
          </v-select>
        </div>
        <span flex></span>
        <v-btn
          depressed
          color="secondary"
          @click="fetch"
          large
        >{{$t('filters.filter_btn')}}</v-btn>
        {{$t('_.or')}}
        <a
          href="#"
          class="ml-2 black--text"
          @click.prevent="resetFilters"
        >{{$t('filters.reinit')}}</a>
      </div>
    </div>
    <div
      layout="row"
      layout-align="start start"
      class="full-width"
    >
      <div
        v-if="loading && !fileDialogEdit && !folderDialogEdit"
        layout="row"
        class="bg-white full-width"
        style="height: 100%; min-height: 400px"
        layout-align="center center"
        flex
      >
        <v-progress-circular
          indeterminate
          color="secondary"
          size="64"
        ></v-progress-circular>
      </div>
      <div
        v-else
        layout="column"
        class="bg-white pa-2 full-width"
        flex
      >
        <div
          v-if="!searching && fil && fil.length"
          layout="row"
          layout-wrap
        >
          <span
            v-for="(f,i) in fil"
            :key="'fil'+i"
          >
            <a
              v-if="i == 0"
              @click.prevent="fetchFiles"
              style="color: #262626"
              :class="currentFolder ? '' : 'font-weight-bold'"
            >{{$t('ged.root')}}</a>
            <span v-else>
              <span class="mx-1">&gt;</span>
              <a
                @click.prevent="fetchFolder(f)"
                style="color: #262626"
                :class="(currentFolder && currentFolder.id == f.id) ? 'font-weight-bold' : ''"
              >{{f.name == 'folder-national' ? $t('ged.nat_lv') : f.name | decode}}</a>
            </span>
          </span>
        </div>
        <div v-else>
          <b style="color: #262626">{{$t('ged.root')}}</b>
        </div>

        <div
          v-if="!searching"
          layout="row"
          layout-align="start stretch"
          layout-wrap
          class="full-width doc-container mt-4"
        >
          <v-card
            v-for="f in files"
            @click.prevent.native="onDocClick(f)"
            :elevation="f.path ? 0 : 24"
            :raised="f.path ? false : true"
            :class="[f.path ? '' : 'folder-card']"
            :outlined="f.path ? true : false"
            class="clickable doc-card ml-doc-card"
            style="margin-bottom: 20px"
            :key="'file_'+f.id"
          >
            <v-card-text
              layout="column"
              style="height: 100%"
              v-if="f.path"
              class="pa-2"
            >
              <span flex></span>
              <div
                layout="row"
                layout-align="center center"
                class="full-width"
              >
                <div
                  v-if="f.loading"
                  layout="column"
                  layout-align="center center"
                  flex="100"
                >
                  <img
                    src="@/assets/file-gray.png"
                    class="preview-img"
                  />
                  <v-progress-circular
                    indeterminate
                    color="secondary"
                    size="30"
                    style="position: absolute"
                  ></v-progress-circular>
                </div>
                <img
                  v-else-if="getImageData(f.id)"
                  :src="getImageData(f.id)"
                  class="preview-img"
                />
                <img
                  v-else
                  src="@/assets/file-gray.png"
                />
              </div>
              <span flex></span>
              <div
                layout="row"
                layout-align="start center"
                class="mt-4"
              >
                <v-icon class="mr-2">mdi-file</v-icon>
                <span
                  :title="f.title ? f.title : f.name | decode"
                  style="max-height: 42px; overflow: hidden; text-overflow: ellipsis;"
                >{{f.title ? f.title : f.name | decode}}</span>
              </div>
            </v-card-text>
            <v-card-text
              v-else
              layout="column"
              style="height: 100%"
              class="pa-2"
            >
              <span flex></span>
              <div
                layout="row"
                layout-align="center center"
                class="full-width"
              >
                <img
                  v-if="getImageData(f.preview_id)"
                  :src="getImageData(f.preview_id)"
                  class="preview-img"
                />
                <img
                  v-else
                  src="@/assets/folder-gray.png"
                />
              </div>
              <span flex></span>
              <div
                layout="row"
                layout-align="start center"
                class="mt-4"
              >
                <v-icon class="mr-2">mdi-folder-outline</v-icon>
                <span
                  :title="f.name == 'folder-national' ? $t('ged.nat_lv') : f.name | decode"
                  style="max-height: 21px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap"
                >{{ f.name == 'folder-national' ? $t('ged.nat_lv') : f.name | decode }}</span>
              </div>
              <div
                layout="row"
                layout-align="start center"
              >
                <v-icon
                  v-if="f.name == 'folder-national'"
                  color="yellow"
                  class="mr-2"
                >mdi-star</v-icon>
                <i class="grey--text">{{f.nb_files}} {{(f.nb_files > 1) ? $t('ged.files')  : $t('ged.file')}}</i>
              </div>
            </v-card-text>
          </v-card>
          <div
            v-if="!files || !files.length"
            layout="row"
            layout-align="center center"
            class="text-xs-center full-width"
            style="height: 270px"
          >
            <em>{{$t('ged.no_file')}}</em>
          </div>
        </div>

        <div v-else>
          <v-list two-line>
            <v-list-tile
              v-for="(f,j) in files"
              :key="f.id"
              avatar
              @click.prevent="onDocClick(f)"
              :style="(j % 2 == 0) ? 'background-color: rgba(0, 0, 0, 0.05)' : ''"
            >
              <div
                style="height: 40px; width: 40px; min-width: 40px; max-width: 40px;"
                class="mr-3 text-xs-center"
              >
                <img
                  v-if="getImageData(f.id)"
                  :src="getImageData(f.id)"
                  style="max-width: 100%; max-height: 100%; margin: auto"
                />
                <img
                  v-else
                  src="@/assets/file-gray.png"
                  style="max-width: 100%; max-height: 100%; margin: auto"
                />
              </div>
              <v-list-tile-content>
                <v-list-tile-title>{{ f.title ? f.title : f.name | decode }}</v-list-tile-title>
                <v-list-tile-sub-title>
                  <div
                    v-if="f.fil && f.fil.length"
                    layout="row"
                    layout-wrap
                  >
                    <span
                      v-for="(fo,i) in f.fil"
                      :key="'fil'+i+f.id"
                    >
                      <span v-if="i == 0">{{$t('ged.root')}}</span>
                      <span v-else>
                        <span class="mx-1">&gt;</span>
                        <span>{{fo.name == 'folder-national' ? $t('ged.nat_lv') : fo.name | decode}}</span>
                      </span>
                    </span>
                  </div>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <div
            v-if="!files || !files.length"
            layout="row"
            layout-align="center center"
            class="text-xs-center full-width"
            style="height: 270px"
          >
            <em>{{$t('ged.no_file_match')}}</em>
          </div>
        </div>
      </div>

      <div
        v-if="isEditor"
        layout="column"
        class="bg-white hidden-sm-and-down pr2-pc pl2-pc pb1-pc pr1-mobile pl1-mobile"
        style="width: 300px; margin-left: 10px"
      >
        <div
          layout="row"
          layout-align="start center"
          class="title grey--text text-uppercase font-weight-medium mb-4 mb2-mobile mt3-pc"
        >
          {{$t('_.actions')}}
        </div>

        <v-btn
          @click="newFolder"
          depressed
          light
          color="transparent"
          class="grey--text ma-0 mb-2 pl-0 ged-btn"
          style="width: fit-content; text-transform: none;"
          :disabled="!editable || searching"
          flat
        >
          <v-icon
            :style="(editable && !searching) ? 'color: black' : ''"
            class="mx-2"
          >mdi-folder-plus-outline</v-icon>
          <span :style="(editable && !searching) ? 'color: black' : ''">{{$t('ged.add_folder')}}</span>
        </v-btn>
        <v-btn
          @click="editFolder(currentFolder)"
          :disabled="!currentFolder || currentFolder.name == 'folder-national' || !editable || searching"
          depressed
          light
          color="transparent"
          class="grey--text ged-btn ma-0 mb-2 pl-0"
          style="width: fit-content; text-transform: none"
          flat
        >
          <v-icon
            class="mx-2"
            :style="(currentFolder && currentFolder.name != 'folder-national' && editable && !searching) ? 'color: black' : ''"
          >mdi-folder-edit-outline</v-icon>
          <span :style="(currentFolder && currentFolder.name != 'folder-national' && editable && !searching) ? 'color: black' : ''">{{$t('ged.edit_folder')}}</span>
        </v-btn>
        <v-btn
          @click="deleteFolderDialog = true"
          :disabled="!currentFolder || currentFolder.name == 'folder-national' || !editable || searching"
          depressed
          light
          color="transparent"
          class="grey--text ged-btn ma-0 mb-2 pl-0"
          style="width: fit-content; text-transform: none"
          flat
        >
          <v-icon
            class="mx-2"
            :style="(currentFolder && currentFolder.name != 'folder-national' && editable && !searching) ? 'color: black' : ''"
          >mdi-folder-remove-outline</v-icon>
          <span :style="(currentFolder && currentFolder.name != 'folder-national' && editable && !searching) ? 'color: black' : ''">{{$t('ged.delete_folder')}}</span>
        </v-btn>
        <v-btn
          @click="newFile"
          :disabled="!editable || searching"
          depressed
          color="transparent"
          light
          class="grey--text ged-btn ma-0 mb-2 pl-0"
          style="width: fit-content; text-transform: none"
          flat
        >
          <v-icon
            class="mx-2"
            :style="(editable && !searching) ? 'color: black' : ''"
          >mdi-file-plus</v-icon>
          <span :style="(editable && !searching) ? 'color: black' : ''">{{$t('ged.add_doc')}}</span>
        </v-btn>
        <div
          v-if="!isAdmin && (!currentFolder || !editable)"
          layout="row"
          layout-align="start center"
          class="caption mb-2"
        >
          <v-icon class="mr-2">mdi-help-circle</v-icon>{{$t('ged.helper')}}
        </div>
      </div>
    </div>
    <v-dialog
      v-if="fileDialogEdit"
      v-model="fileDialogEdit"
      max-width="700"
      content-class="edit-dialog"
      :fullscreen="$vuetify.breakpoint. smAndDown"
    >
      <div
        v-if="loading"
        layout="row"
        class="bg-white"
        style="height: 100%; min-height: 200px"
        layout-align="center center"
      >
        <v-progress-circular
          indeterminate
          color="secondary"
          size="64"
        ></v-progress-circular>
      </div>
      <v-card
        @click.native="closeEmoji"
        v-else
      >
        <v-card-title class="title">
          <v-icon
            color="secondary"
            class="mr-2"
          >mdi-paperclip</v-icon>
          {{ editingFile.id ? $t('ged.edit') : $t('ged.add_doc')}}
          <v-spacer></v-spacer>
          <v-btn
            class="ma-0"
            icon
            @click="fileDialogEdit = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div
            v-if="!editingFile.id"
            layout="column"
            layout-align="center center"
            class="mb-3"
          >
            <div
              @dragover.prevent
              @drop="dragFile"
              @click.prevent="pickFile"
              @keyup.enter="pickFile"
              layout="column"
              layout-align="center center"
              class="upload-zone clickable text-truncate pa-1"
            >
              <span class="grey--text auto-break-text text-xs-center">{{$t('messages.doc_depos')}}</span>
            </div>
            <input
              type="file"
              style="display: none"
              ref="documentFile"
              @change="onFilePicked"
            >
          </div>

          <v-text-field
            v-model="editingFile.title"
            :label="$t('ged.doc_name')"
          ></v-text-field>

          <v-checkbox
            v-model="editingFile.message.has_message"
            :false-value="0"
            :true-value="1"
            :label="$t('ged.has_message')"
          ></v-checkbox>
          <div v-if="editingFile.message.has_message">
            <div>
              <v-textarea
                hide-details
                flat
                :placeholder="$t('messages.new_placeholder2')"
                class="full-width body-area"
                ref="body_ref"
                name="body_area"
                v-model="editingFile.message.body"
              ></v-textarea>

              <div
                layout="row"
                layout-align="start center"
              >
                <v-btn
                  icon
                  class="mx-0"
                  @click.prevent.stop="toogleDialogEmoji"
                >
                  <v-icon color="secondary">mdi-emoticon-happy-outline</v-icon>
                </v-btn>
              </div>

              <div
                v-click-outside="closeEmoji"
                :hidden="dialogHidden"
                :style="emojiStyle"
              >
                <VEmojiPicker
                  @click.native.stop="() => {}"
                  :pack="emojisNative"
                  labelSearch
                  @select="onSelectEmoji"
                />
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="secondary"
            @click="editingFile.id ? saveFile() : createFile()"
            style="text-transform: none"
          >{{$t('_.validate')}}</v-btn>
          &nbsp;{{$t('_.or')}}&nbsp;
          <a
            @click.prevent="fileDialogEdit = false"
            href="#"
            class="black--text"
          >{{$t('_.cancel')}}</a>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="folderDialogEdit"
      max-width="700"
      :fullscreen="$vuetify.breakpoint. smAndDown"
    >
      <div
        v-if="loading"
        layout="row"
        class="bg-white"
        style="height: 100%; min-height: 200px"
        layout-align="center center"
      >
        <v-progress-circular
          indeterminate
          color="secondary"
          size="64"
        ></v-progress-circular>
      </div>
      <v-card v-else>
        <v-card-title class="title">
          <v-icon
            color="secondary"
            class="mr-2"
          >mdi-folder</v-icon>
          {{ editingFolder.id ? $t('ged.edit_folder') : $t('ged.add_folder')}}
          <v-spacer></v-spacer>
          <v-btn
            class="ma-0"
            icon
            @click="folderDialogEdit = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="newFolderName"
            @keyup.enter="editingFolder.id ? saveFolder() : createFolder()"
            :label="$t('ged.folder_name')"
          >
          </v-text-field>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="secondary"
            @click="editingFolder.id ? saveFolder() : createFolder()"
            style="text-transform: none"
          >{{$t('_.validate')}}</v-btn>
          &nbsp;{{$t('_.or')}}&nbsp;
          <a
            @click.prevent="folderDialogEdit = false"
            href="#"
            class="black--text"
          >{{$t('_.cancel')}}</a>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="detailDialog"
      max-width="700"
      :fullscreen="$vuetify.breakpoint. smAndDown"
    >
      <v-card>
        <v-card-title class="title">
          <v-icon
            color="secondary"
            class="mr-2"
          >mdi-eye</v-icon>
          {{$t('ged.zoom')}}
          <v-spacer></v-spacer>
          <v-btn
            class="ma-0"
            icon
            @click="detailDialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-4 py1-mobile full-width">
          <div
            layout="row"
            class="full-width"
            layout-wrap
          >
            <div
              layout="column"
              layout-align="center center"
              class="hidden-sm-and-down"
              flex="35"
            >
              <img
                v-if="getImageData(editingFile.id)"
                :src="getImageData(editingFile.id)"
                class="preview-details"
              />
              <img
                v-else
                src="@/assets/file-gray.png"
              />
            </div>
            <div
              layout="column"
              class="ml2-pc"
              flex
            >
              <div class="title break-word full-width mt-1 mb-3">{{editingFile.title ? editingFile.title : editingFile.name | decode}}</div>
              <div
                layout="row"
                layout-align="start start"
                class="mb-4"
              >
                <avatar
                  v-if="isMEN && $store.state.men_logo"
                  size="25"
                  :image="$store.state.men_logo"
                  :fullname="editingFile.created_by"
                ></avatar>
                <avatar
                  v-else
                  size="25"
                  :image="getImageData(editingFile.creator_id)"
                  :fullname="editingFile.created_by"
                ></avatar>
                <div
                  layout="column"
                  layout-align="center start"
                  class="ml-2"
                >
                  <div
                    layout="row"
                    class="pl-1"
                  >
                    {{$t('_.by')}}&nbsp;
                    <b v-if="isCurrent">
                      {{$t('_.yourself')}}
                    </b>
                    <b v-else-if="isMEN">
                      {{$t('_.the')}} MEN
                    </b>
                    <b v-else-if="editingFile.creator.is_deleted">
                      {{$t('users.inactive')}}
                    </b>
                    <b v-else>
                      {{editingFile.creator.firstname}} {{editingFile.creator.lastname}}
                    </b>
                    <span
                      v-if="isMEN && isAdmin && !isCurrent"
                      class="ml-1 hidden-sm-and-down"
                    >
                      ({{editingFile.creator.firstname}} {{editingFile.creator.lastname}})
                    </span>
                  </div>
                  <div
                    layout="row"
                    layout-align="start center"
                  >
                    <v-chip
                      label
                      :color="isMEN ? levelColor(ministry) : levelColor(editingFile.creator.level)"
                      class="text-lowercase mr-2"
                      text-color="white"
                      style="width: fit-content"
                      small
                    >
                      {{isMEN ? levelLabel(ministry) : levelLabel(editingFile.creator.level)}}
                    </v-chip>
                    <span class="hidden-sm-and-down">{{$t('_.on')}} {{formatDateHumanI18n(editingFile.created_at)}} {{$t('_.at')}} {{formatHour(editingFile.created_at)}}</span>
                  </div>
                </div>
              </div>
              <div class="break-word">{{editingFile.name}}</div>
              <div>{{$t('ged.emp')}} {{currentFolder ? (currentFolder.name == 'folder-national' ?  $t('ged.nat_lv') : currentFolder.name) : $t('ged.root') | decode}}</div>
              <div v-if="editingFile.size">{{$t('ged.size')}} {{editingFile.size | prettyBytes}}</div>
              <div
                layout="row"
                layout-align="start center"
                layout-wrap
                class="mt-4"
              >
                <v-btn
                  @click.native="downloadDocument(editingFile)"
                  style="text-transform: none"
                  color="secondary"
                  depressed
                  class="mx-0"
                  large
                >
                  <v-icon class="mr-2">mdi-cloud-download</v-icon>
                  {{$t('ged.download')}}
                </v-btn>
                <v-btn
                  @click="editFile(editingFile)"
                  v-if="editable"
                  icon
                  color="secondary"
                  depressed
                  large
                  class="mx-3"
                  outline
                >
                  <v-icon color="secondary">mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  @click="deleteFileDialog = true"
                  v-if="editable"
                  icon
                  color="error"
                  large
                  class="ml-0"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
            </div>
            <div
              layout="column"
              class="hidden-md-and-up mt-2"
              flex="100"
            >
              <img
                v-if="getImageData(editingFile.id)"
                :src="getImageData(editingFile.id)"
                class="preview-details"
              />
            </div>
          </div>
          <div
            v-if="editingFile.message && editingFile.message.id"
            layout="column"
            style="white-space: pre-wrap; word-wrap: break-word;font-family: inherit;"
            class="mt-5"
            flex
          >{{editingFile.message.body}}</div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteFileDialog"
      max-width="300"
    >
      <v-card>
        <v-card-title class="title">{{$t('ged.delete_doc')}}</v-card-title>
        <v-card-text>
          {{$t('ged.delete_doc_details')}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            flat="flat"
            @click="deleteFileDialog = false"
          >
            {{$t('_.cancel')}}
          </v-btn>
          <v-btn
            color="error"
            depressed
            @click="deleteFileDialog = false; deleteDocument(editingFile)"
          >
            {{$t('_.delete')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteFolderDialog"
      max-width="300"
    >
      <v-card>
        <v-card-title class="title">{{$t('ged.delete_folder_dialog')}}</v-card-title>
        <v-card-text>
          {{$t('ged.delete_folder_details')}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            flat="flat"
            @click="deleteFolderDialog = false"
          >
            {{$t('_.cancel')}}
          </v-btn>
          <v-btn
            color="error"
            depressed
            @click="deleteFolderDialog = false; deleteFolder(currentFolder)"
          >
            {{$t('_.delete')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Documents from '@/api/documents'
import I18nMixin from '@/mixins/i18n'
import Consts from '@/consts'
import ImageMixin from '@/mixins/image'
import Avatar from '@/components/shared/Avatar.vue'
import Auth from '@/plugins/auth'
import FormDataMixin from '@/mixins/formdata'
import VEmojiPicker from "v-emoji-picker"
import packData from "v-emoji-picker/data/emojis.js"
import axios from 'axios'

export default {
  mixins: [I18nMixin, ImageMixin, FormDataMixin],
  components: { Avatar, VEmojiPicker },
  data () {
    return {
      filters: {
        keywords: null,
        level: []
      },
      storeKey: 'documents',
      files: [],
      displayFilters: false,
      imgs: {},
      imgsLoad: {},
      loading: false,
      detailDialog: false,
      currentFolder: null,
      folderDialog: false,
      newFolderName: null,
      editingFolder: {},
      editingFile: {
        title: '',
        message: {
          body: '',
          has_message: 0
        },
        creator: {}
      },
      folderDialogEdit: false,
      fileDialogEdit: false,
      fileData: null,
      fil: [],
      dialogHidden: true,
      deleteFileDialog: false,
      deleteFolderDialog: false,
      source: null,
      searching: false
    }
  },
  mounted() {
    const storedFilters = this.$store.getters.getFilters(this.storeKey)
    if (storedFilters) {
      this.filters = storedFilters
    }

    this.fetchFiles()
  },
  methods: {
    fetchFiles () {
      this.loading = true
      this.currentFolder = null
      Documents.getRoot(this.filters).then(res => {
        if (this.filters.keywords || (this.filters.level && this.filters.level.length)) {
          this.searching = true
        } else {
          this.searching = false
        }
        this.files = res.data
        this.fil = []
        this.loading = false
        this.$store.commit('LOAD_LOGO')
        this.loadPreviews()
        this.$store.commit('SET_FILTERS', {key: this.storeKey, data: this.filters})
      })
    },
    loadPreviews () {
      for (let i = 0; i < this.files.length; i++) {
        const f = this.files[i]
        if (f.preview_id) {
          if (f.path) {
            this.getImage('/assets/documents/' + f.id, f.id)
          } else {
            this.getImage('/assets/documents/' + f.preview_id, f.preview_id)
          }
        }
      }
    },
    resetFile () {
      this.editingFile = {
        title: '',
        message: {
          body: '',
          has_message: 0
        },
        creator: {}
      }
    },
    pickFile () {
      this.$refs.documentFile.click()
    },
    onFilePicked (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        if (files[0].size > Auth.user.upload_limit) {
          this.$snotify.error(this.$t('_.file_limit'))
          return
        }
        this.fileData = files[0]
        this.editingFile.title = files[0].name
      }
    },
    dragFile (e) {
      e.stopPropagation()
      e.preventDefault()
      var files = e.dataTransfer.files
      if (files[0] !== undefined) {
        if (files[0].size > Auth.user.upload_limit) {
          this.$snotify.error(this.$t('_.file_limit'))
          return
        }
        const f = files[0]
        this.fileData = f
        this.editingFile.title = f.name
      }
    },
    createFile () {
      let formData = new FormData()
      formData.append("files[0]", this.fileData, this.fileData.name)

      if (this.editingFile.message && this.editingFile.message.has_message) {
        this.editingFile.message.subject = this.$t('ged.new') + ' : ' + this.editingFile.title
      }

      let param = { param: this.editingFile }
      this._convertObjectToFormData(formData, param)
      this.loading = true

      Documents.newFile(formData).then(res => {
        this.loading = false
        this.fileDialogEdit = false
        let f = res.data.docs[0]
        f.loading = true
        this.files.push(f)
        this.$snotify.success(this.$t('ged.added'))
        this.generatePreview(f)
      }, () => {
        this.loading = false
      })
    },

    generatePreview (doc) {
      axios.get(`/files/` + doc.id + `/preview`).then(res => {
        if (res && res.data) {
          for (let i = 0; i < this.files.length; i++) {
            if (this.files[i].id == doc.id) {
              this.files[i].preview_id = res.data.id
              this.files[i].loading = false
              this.loadPreviews()
              break
            }
          }
        }
      }, () => {
        for (let i = 0; i < this.files.length; i++) {
          if (this.files[i].id == doc.id) {
            this.files[i].loading = false
            break
          }
        }
      })
    },
    downloadDocument (doc) {
      Documents.getFile(doc.id).then(res => {
        this.downloadFile(res.data, doc.name)
      })
    },
    deleteDocument (doc) {
      Documents.deleteFile(doc.id).then(() => {
        this.fetch()
        this.deleteFileDialog = false
        this.detailDialog = false
        this.resetFile()
        this.$snotify.success(this.$t('ged.deleted'))
      })
    },
    onDocClick (doc) {
      if (doc.path) {
        this.editingFile = doc
        this.detailDialog = true
      }
      else {
        this.fetchFolder(doc)
      }
    },
    fetchFolder (doc) {
      this.loading = true
      this.currentFolder = doc
      Documents.getFolder(doc.id, this.filters).then(res => {
        if (this.filters.keywords || (this.filters.level && this.filters.level.length)) {
          this.searching = true
          this.fil = []
        } else {
          this.searching = false
          this.fil = res.data.fil
        }

        this.files = res.data.results
        this.loading = false
        this.loadPreviews()
      })
    },
    deleteFolder (folder) {
      let params = []
      for (let i = 0; i < this.files.length; i++) {
        params.push(this.files[i].id)
      }
      Documents.deleteFolderContent(folder.id, { files: params, folders: params }).then(() => {
        this.fetchFiles()
        this.deleteFolderDialog = false
        this.$snotify.success(this.$t('ged.folder_deleted'))
      })
    },
    fetch () {
      if (this.currentFolder) {
        this.fetchFolder(this.currentFolder)
      }
      else {
        this.fetchFiles()
      }
    },
    createFolder () {
      this.loading = true
      Documents.newFolder({ name: this.newFolderName, parent_id: this.currentFolder ? this.currentFolder.id : null }).then(() => {
        this.fetch()
        this.newFolderName = null
        this.folderDialogEdit = false
        this.loading = false
        this.$snotify.success(this.$t('ged.folder_created'))
      }, () => {
        this.loading = false
      })
    },
    editFolder (folder) {
      const f = folder
      this.newFolderName = f.name
      this.editingFolder = f
      this.folderDialogEdit = true
    },
    newFile () {
      this.editingFile = {
        title: '',
        folder_id: this.currentFolder ? this.currentFolder.id : null,
        message: {
          body: '',
          has_message: 0
        },
        creator: {}
      }
      this.fileDialogEdit = true
    },
    newFolder () {
      this.newFolderName = ''
      this.editingFolder = {}
      this.folderDialogEdit = true
    },
    editFile (file) {
      this.editingFile = JSON.parse(JSON.stringify(file))
      if (this.editingFile.message) {
        this.editingFile.message.has_message = 1
      } else {
        this.editingFile.message = {
          body: '',
          has_message: 0
        }
      }

      this.fileDialogEdit = true
      this.detailDialog = false
    },
    saveFolder () {
      this.loading = true
      Documents.updateFolder(this.editingFolder.id, { name: this.newFolderName }).then(() => {
        this.fetch()
        this.newFolderName = null
        this.editingFolder = {}
        this.folderDialogEdit = false
        this.loading = false
        this.$snotify.success(this.$t('ged.folder_edited'))
      }, () => {
        this.loading = false
      })
    },
    saveFile () {
      this.loading = true

      if (this.editingFile.message && this.editingFile.message.has_message) {
        this.editingFile.message.subject = this.$t('ged.new') + ' : ' + this.editingFile.title
      }

      Documents.updateFile(this.editingFile.id, this.editingFile).then(() => {
        this.fetch()
        this.fileDialogEdit = false
        this.resetFile()
        this.loading = false
        this.$snotify.success(this.$t('ged.edited'))
      }, () => {
        this.loading = false
      })
    },
    resetFilters () {
      this.filters = {
        keywords: null,
        level: [],
      }
      this.fetch()
    },
    closeEmoji () {
      this.dialogHidden = true
    },
    toogleDialogEmoji () {
      this.dialogHidden = !this.dialogHidden
      if (!this.dialogHidden) {
        this.$refs.body_ref.focus()
      }
    },
    onSelectEmoji (dataEmoji) {
      let value = dataEmoji.emoji

      let textArea = document.getElementsByName('body_area')[0]
      let startPos = textArea.selectionStart,
        // get cursor's position:
        endPos = textArea.selectionEnd,
        cursorPos = startPos,
        tmpStr = textArea.value

      if (value === null) {
        return
      }

      // insert:
      this.editingFile.message.body = tmpStr.substring(0, startPos) + value + tmpStr.substring(endPos, tmpStr.length)

      // move cursor:
      setTimeout(() => {
        cursorPos += value.length
        textArea.selectionStart = textArea.selectionEnd = cursorPos
        this.$refs.body_ref.focus()
      }, 10)
    },
    levelLabel (l) {
      switch (l) {
        case Consts.MINISTRY:
          return this.$t('users.lv_min')
        case Consts.NATIONAL:
          return this.$t('users.lv_nat')
        case Consts.SECTORAL:
          return this.$t('users.lv_sec')
        case Consts.LOCAL:
          return this.$t('users.lv_loc')
      }
    },
    levelColor (l) {
      switch (l) {
        case Consts.MINISTRY:
          return 'primary'
        case Consts.NATIONAL:
          return 'pink'
        case Consts.SECTORAL:
          return 'secondary'
        case Consts.LOCAL:
          return 'brown'
      }
    },
  },
  computed: {
    levels () {
      return [
        { value: Consts.MINISTRY, text: this.$t('users.lv_min') },
        { value: Consts.NATIONAL, text: this.$t('users.lv_nat') },
      ]
    },
    isAdmin () {
      return Auth.user.is_admin
    },
    emojisNative () {
      return packData
    },
    isMEN () {
      if (this.editingFile.creator.is_admin || this.editingFile.creator.level == Consts.MINISTRY) {
        return true
      }
      return false
    },
    isCurrent () {
      if (Auth.user.id == this.editingFile.creator_id) {
        return true
      }
      return false
    },
    ministry () {
      return Consts.MINISTRY
    },
    isEditor () {
      if (Auth.user.is_admin || Auth.user.level == Consts.MINISTRY || Auth.user.level == Consts.NATIONAL) {
        return true
      }
      return false
    },
    editable () {
      if (Auth.user.level == Consts.MINISTRY || this.isAdmin) {
        return true
      } else if (Auth.user.level == Consts.NATIONAL) {
        if (this.fil && this.fil[1] && this.fil[1].name == 'folder-national') {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    emojiStyle () {
      if (this.$vuetify.breakpoint.smAndDown) {
        return "position: absolute; z-index: 250"
      } else {
        return "position: fixed"
      }
    }
  },
  directives: {
    'click-outside': {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // here I check that click was outside the el and his childrens
          if (!(el == event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      },
    }
  },
  filters: {
    decode (str) {
      let textArea = document.createElement('textarea')
      textArea.innerHTML = str
      return textArea.value
    }
  },
}
</script>
<style scoped>
.preview-img {
  max-width: 65%;
}
.preview-details {
  max-width: 100%;
  border: 1px solid lightgrey;
}
.upload-zone {
  height: 150px;
  border: 2px dashed grey;
  border-radius: 7% 7%;
}
@media screen and (max-width: 960px) {
  .upload-zone {
    width: 90%;
  }
}
@media screen and (min-width: 960px) {
  .doc-card {
    /*width: 31%;*/
    width: 230px;
  }
  .ml-doc-card {
    /*margin-left: 1.75%;*/
    margin-left: 20px;
  }
  .upload-zone {
    width: 50%;
  }
  .doc-container {
    padding-right: 20px;
  }
}
@media screen and (max-width: 960px) {
  .doc-card {
    width: 45%;
  }
  .ml-doc-card {
    margin-left: 5%;
  }
  .doc-container {
    padding-right: 5%;
  }
}
.folder-card {
  -webkit-box-shadow: 7px 7px 7px 0px lightgrey;
  -moz-box-shadow: 7px 7px 7px 0px lightgrey;
  box-shadow: 7px 7px 5px 7px lightgrey;
}
</style>
<style>
.edit-dialog {
  overflow-y: visible;
}
.ged-btn {
  display: table;
}
.ged-btn > .v-btn__content {
  height: 100%;
  margin: auto;
  vertical-align: middle;
}
.body-area > .v-input__control > .v-input__slot {
  padding-bottom: 16px;
}
</style>
